import React from "react";

const OmanProcedure = () => {
  return (
    <div className="pccExpContainer">
      <h2>
        Procedure for Oman<span>    PCC</span> Verification in Bangalore{" "}
      </h2>
      <p>
        The process of obtaining and verifying an Oman PCC involves several
        steps. Goodway Attestation Services ensures that each step is
        meticulously followed to guarantee the authenticity and acceptance of
        your PCC in Oman. The main steps in the Oman PCC verification process
        include:
      </p>
      <ul>
        <li>
          <h3>
            <span>1.</span> Application Submission:
          </h3>{" "}
          The first step involves submitting the PCC application to the relevant
          police department or government agency.
        </li>
        <li>
          <h3>
            <span>2.</span> Background Check:
          </h3>{" "}
          The police department conducts a thorough background check to ensure
          that the applicant has no criminal record.
        </li>
        <li>
          <h3>
            <span>3.</span> Issuance of PCC:
          </h3>{" "}
          Once the background check is complete, the police department issues
          the PCC.
        </li>
        <li>
          <h3>
            {" "}
            <span>4.</span>State Home Department Attestation:
          </h3>{" "}
          The issued PCC is then attested by the State Home Department.
        </li>
        <li>
          <h3>
            {" "}
            <span>5.</span> Ministry of External Affairs (MEA) Attestation:
          </h3>{" "}
          The document is further attested by the MEA to confirm its
          authenticity for international use.
        </li>
        <li>
          <h3>
            {" "}
            <span>6.</span> Embassy Attestation:
          </h3>{" "}
          Finally, the document is attested by the Oman Embassy to ensure its
          recognition in Oman.
        </li>
      </ul>
    </div>
  );
};

export default OmanProcedure;
